import {useDispatch, useSelector} from "react-redux";
import Input from "../general/input/Input";
import {Button} from "../general/input/Button";
import "./auth.css"
import {env} from "../../res/config/env";
import {useCallback, useState} from "react";
import usePasswordReset from "../state/account/usePasswordReset";
import LogoWithText from "../../branding/component/logo/LogoWithText";
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from "react-google-recaptcha-v3";

const PasswordReset = ({ userName, hideReset, onSuccess }) => {

    const { sendResetRequest, loadingRequest, requestResult } = usePasswordReset();
    const [ requestSent, setRequestSent ] = useState(false);
    // const { executeRecaptcha } = useGoogleReCaptcha();
    // const [ loadingCaptcha, setLoadingCaptcha ] = useState(false);

    // const handleReCaptchaVerify = useCallback(async () => {
    //     if (!executeRecaptcha) {
    //         return {blocked: true};
    //     }
    //     setLoadingCaptcha(true);
    //     const token = await executeRecaptcha('login');
    //     setLoadingCaptcha(false);
    //     return {captchaToken: token};
    // }, [executeRecaptcha]);

    const resetPassword = () => {
        sendResetRequest(userName);
        setRequestSent(true);
    }

    if(requestSent && !loadingRequest && requestResult) {
        onSuccess();
    }

    return (
        <>
            <Button className={loadingRequest ? "button-loading" : ""} onClick={resetPassword}>Reset Password</Button>
            <Button className="button_clear" onClick={hideReset}>Back</Button>
        </>
    )
}

const getErrorDisplayText = (loginMethod, error) => {
    if(!error) return;

    if(error.toLowerCase() === "request failed with status code 401"){
        return `Invalid ${loginMethod} or Password. Please double-check your credentials and try again.`;
    } else {
        return "Error from server: " + error;
    }
}

const PasswordResetSent = ({ onHide }) => {
    return (
        <div className="password-request-sent">
            <h2>Password Reset</h2>
            <p>
                A password reset link has been sent to your <span className="emphasis">Email</span>! When you
                receive it, please click the link to open a window where you can enter a new password.
            </p>
            <Button className="button_clear" onClick={onHide}>
                Back
            </Button>
        </div>
    )
}

const PasswordResetForm = ({ onHide, onBack }) => {

    const [userName, setUserName] = useState('');
    const loginMethod = env.USER_NAME_TYPE;
    const [isReset, setIsReset ] = useState(false);

    const onPassReset = () => {
        setIsReset(true);
    }

    if(isReset) {
        return <PasswordResetSent onHide={onHide} />;
    } else {
        return (
            <>
                <Input hint={loginMethod} value={userName} onChange={(e) => setUserName(e.target.value)} />
                <PasswordReset
                    hideReset={onBack}
                    userName={userName}
                    onSuccess={onPassReset}
                />
            </>
        )
    }
}

const LoginForm = ({ onResetPassword, onHide }) => {

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [ loadingCaptcha, setLoadingCaptcha ] = useState(false);
    const loginMethod = env.USER_NAME_TYPE;

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            return {blocked: true};
        }
        setLoadingCaptcha(true);
        const token = await executeRecaptcha('login');
        setLoadingCaptcha(false);
        return {captchaToken: token};
    }, [executeRecaptcha]);

    const onUserNameChanged = (event) => {
        setUserName(event.target.value);
    }
    const onPasswordChanged = (event) => {
        setPassword(event.target.value)
    }

    const { loading : authLoading } = useSelector(
        (state) => state.auth
    )

    const loading = authLoading || loadingCaptcha;

    const doLogIn = async (captchaToken) => {
        // Bad fix for issue:
        // When importing as normal, get "can't access lexical declaration 'login' before initialization"
        const { login } = await import("../../redux/action/authActions");
        dispatch(login({userName, password, captchaToken}))
    }

    const dispatch = useDispatch();
    const tryLogin = async () => {
        if(loading) return;

        const captchaRes = await handleReCaptchaVerify();
        if(captchaRes.blocked) {
            // TODO error report to user
            await doLogIn(null);
        } else {
            const { captchaToken } = captchaRes;
            await doLogIn(captchaToken);
        }
    }

    return (
        <>
            <Input hint={loginMethod} value={userName} onChange={onUserNameChanged} />
            <Input type="password" hint="Password" value={password} onChange={onPasswordChanged} />
            <p id="forgotten-pass" onClick={onResetPassword}>Forgotten your password?</p>
            <Button
                onClick={tryLogin}
                className={loading ? "button-loading" : ""}>
                Log In
            </Button>
            {onHide &&
                <Button className="button_clear" onClick={onHide}>
                    Back
                </Button>
            }
        </>
    );
}

const Login = ({ onHide }) => {

    const { error } = useSelector(
        (state) => state.auth
    )
    // const [ localError, setLocalError ] = useState("");
    const [ showLogin, setShowLogin ] = useState(true);
    const loginMethod = env.USER_NAME_TYPE;
    const errorText = getErrorDisplayText(loginMethod, error);

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={env.CAPTCHA_KEY}
        >
            <div className="log-in-layout">
                <LogoWithText />
                {errorText &&
                    <div className="auth-warning">
                        {errorText}
                    </div>
                }
                {showLogin ?
                    <LoginForm
                        onHide={onHide}
                        onResetPassword={() => setShowLogin(false)}
                    /> :
                    <PasswordResetForm
                        onHide={onHide}
                        onBack={() => setShowLogin(true)}
                    />
                }
            </div>
        </GoogleReCaptchaProvider>
    )
}

export default Login;